import React from 'react';
import styled from 'styled-components';
import Button from '../atoms/Button';

export const ConfirmSt = {
  Dimmed: styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 12;
    background-color: rgba(0, 0, 0, 0.5);
  `,
  Wrap: styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    width: 407px;
    transform: translate(-50%, -50%);
    z-index: 13;
    background-color: #fff;
    box-shadow: 1px 1px 10px 0 #00000026;
    border-radius: 16px;
  `,
  Inner: styled.div`
    padding: 32px 24px 24px;
  `,
  Text: styled.p`
    font-weight: 500;
    color: #192640;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 40px;
    word-break: break-word;
  `,
  BtnArea: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
};

const Confirm = ({ text, cancelFunc, submitFunc }) => {
  return (
    <>
      <ConfirmSt.Dimmed></ConfirmSt.Dimmed>
      <ConfirmSt.Wrap>
        <ConfirmSt.Inner>
          <ConfirmSt.Text>{text}</ConfirmSt.Text>
          <ConfirmSt.BtnArea>
            {!!cancelFunc && <Button $colorType={'white'} width={98} height={50} text={'취소'} style={{ marginRight: 8 }} onClick={cancelFunc && cancelFunc} />}
            <Button $colorType={'peacock'} width={98} height={50} text={'확인'} onClick={submitFunc} />
          </ConfirmSt.BtnArea>
        </ConfirmSt.Inner>
      </ConfirmSt.Wrap>
    </>
  );
};

export default Confirm;
